import "../App.css";
import Header from "../screens/Header";
import Footer from "../screens/Footer";
import ScrollUpBtn from "../components/ScrollUpBtn";
import CompanyDetailsScreen from "../screens/CompanyDetailsScreen";

function RefundAndReturnPolicy() {
  return (
    <div className="App">
      <Header />
      <CompanyDetailsScreen />
      <Footer />
      <ScrollUpBtn />
    </div>
  );
}

export default RefundAndReturnPolicy;
